import { apiservice } from "../service/api";

export async function deleteFlag(params) {
  const res = await apiservice({
    path: "/adv/deleteflag/" + params,
    method: "delete",
    body: {
      id: params,
    },
  });

  if (res.status == 200) {
    return true;
  } else {
    return false;
  }
}
